import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';
import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';

export const PASSPORT_ERROR = 'Некорректные паспортные данные';

export const validatePassportSeries = (value: TValidatorValue) => {
    if (getNumbersFromStr(value)?.length !== 4) return PASSPORT_ERROR;

    return undefined;
};
